<div class="relative" appClickOutside (clickOutside)="showMenu.set(false)">
  <palantir-button
    palantir-empty-state-action
    [attr.theme]="theme"
    [attr.size]="size"
    layout="suffix"
    [icon]="'expand-more-outline'"
    (click)="toggle()"
  >
    {{ title }}
  </palantir-button>
  @if (showMenu()) {
    <div
      [class]="
        position +
        ' z-50 absolute bg-white min-w-[240px] w-[240px] rounded-lg border border-solid border-color-light-shade p-2 shadow-md'
      "
      [@fadeInOut]
      [ngClass]="{
        'top-11': size === 'base',
        'top-9': size === 'xs',
      }"
    >
      <ng-content></ng-content>
    </div>
  }
</div>
